import { AnimatePresence, motion } from 'framer-motion';
import { createPortal } from 'react-dom';
import { useUiStore } from '@/store/ui.store';
import { SidebarContent } from './Sidebar';

export function MobileNav() {
  const open = useUiStore((s) => s.mobileNavOpen);
  const setOpen = useUiStore((s) => s.setMobileNav);

  return createPortal(
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <motion.div
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
          />
          <motion.div
            className="absolute left-0 top-0 h-full w-[280px] border-r border-line bg-surface"
            initial={{ x: '-100%' }}
            animate={{ x: 0 }}
            exit={{ x: '-100%' }}
            transition={{ type: 'tween', duration: 0.22, ease: 'easeOut' }}
          >
            <SidebarContent onNavigate={() => setOpen(false)} />
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body,
  );
}
